import { IsDate, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { SmsAttemptStatus } from '../sms-attempt-status.enum';
import { SmsTriggers } from '../sms-triggered.enum';

export class SmsAttemptDto {
  @IsString()
  @IsNotEmpty()
  triggered!: SmsTriggers;

  @IsDate()
  @IsNotEmpty()
  date!: Date;

  @IsString()
  @IsNotEmpty()
  status!: SmsAttemptStatus;

  @IsOptional()
  @IsString()
  failureReason?: string;

  @IsOptional()
  metadata?: Record<string, unknown>;
}
